import { format } from 'owa-localize';

import { getUserTimeZone } from 'owa-session-store';
import getTimeZoneDisplayName from './getTimeZoneDisplayName';

export default (formatString: string, timeZoneId: string = getUserTimeZone()) =>
    format(formatString, getTimeZoneDisplayName(timeZoneId));
